import DynamicModal from 'modals/scripts/dynamic_modal'

const MODAL_SELECTOR = '#listingSocialShare'

class ListingSocialShare {
  static async init () {
    return new ListingSocialShare()
  }

  constructor () {
    this.bindEvents()
  }

  bindEvents () {
    $('#listing-social-share-button').on('click', this.openModal.bind(this))
  }

  openModal (e) {
    e.preventDefault()

    const $trigger = $(e.currentTarget)
    const listingUrl = $trigger.data('url')
    const listingTitle = $trigger.data('title')

    const modal = new DynamicModal(MODAL_SELECTOR, {
      size: 'md',
      header_title: `${I18n.t('share')}: ${listingTitle}`,
      class_name: 'listing-show__share-modal'
    })

    modal.$body.html(this.shareButtonsHtml(listingUrl, listingTitle))
    modal.open()
  }

  shareButtonsHtml (url, title) {
    return `
      <div class="d-flex flex-wrap">
        <a class="btn btn-facebook" href="https://www.facebook.com/sharer/sharer.php?u=${url}&t=${title}" rel="noopener" target="_blank" title="Facebook">
          <i class="fa-facebook-f fa-brands" aria-hidden="true"></i>
        </a>
        <a class="btn btn-twitter" href="https://twitter.com/intent/tweet?url=${url}&text=${title}" rel="noopener" target="_blank" title="Twitter">
          <i class="fa fa-x-twitter fa-brands" aria-hidden="true"></i>
        </a>
        <a class="btn btn-linkedin" href="https://www.linkedin.com/sharing/share-offsite/?url=${url}" rel="noopener" target="_blank" title="LinkedIn">
          <i class="fa-linkedin-in fa-brands" aria-hidden="true"></i>
        </a>
        <a class="btn btn-pinterest" href="https://www.pinterest.com/pin/create/button?url=${url}" rel="noopener" target="_blank" title="Pinterest">
          <i class="fa fa-pinterest-p fa-brands" aria-hidden="true"></i>
        </a>
        <a class="btn btn-whatsapp" href="https://api.whatsapp.com/send?text=${url}" rel="noopener" target="_blank" title="WhatsApp">
          <i class="fa fa-whatsapp fa-brands" aria-hidden="true"></i>
        </a>
        <a class="btn btn-telegram" href="https://t.me/share/url?url=${url}" rel="noopener" target="_blank" title="Telegram">
          <i class="fa-solid fa-paper-plane" aria-hidden="true"></i>
        </a>
      </div>
    `
  }
}

export default ListingSocialShare
